import React from 'react';
import { Button } from '@material-ui/core';
import PropTypes from "prop-types";

const StyledButton = ({
  size = 'small',
  variant = 'outlined',
  onClick,
  fullWidth = false,
  classNames='',
  ...restProps
}) => (
    <Button
      size={size}
      variant={variant}
      onClick={onClick}
      fullWidth={fullWidth}
      className={classNames}
      {...restProps}
    />
  );

  StyledButton.propTypes = {
    size: PropTypes.oneOf(['small', 'medium', 'large']),
    variant: PropTypes.oneOf(['text', 'outlined', 'contained']),
    onClick: PropTypes.func,
    fullWidth: PropTypes.bool,
    classNames: PropTypes.string,
    startIcon: PropTypes.node,
  };

export default StyledButton;
